import React from 'react';

import {
  FormVariant,
  formVariantsOptions,
} from 'app/pages/loanApplication/tabs/tasks/Tasks.constants';
import { FormViewer } from 'app/pages/system/forms';
import CreateFormModal from 'app/shared/modules/CreateFormModal';
import _ from 'lodash';

import { LoxDocumentTypeName } from 'constants/forms';
import { NATIONAL_CATEGORY_CODE } from 'constants/states';

import { NEW_FORM_DIALOG_HEADER, PickerTab } from './AddConditionsForm.constants';

const buildFormParams = ({ name, formId, formType }) => ({
  name,
  formId,
  formType,
  selectedPage: 1,
});

export const applyUploadedFormToConditionTask = ({
  form,
  conditionId,
  taskTypeId,
  uploadedForm,
}) => {
  const newForm = _.cloneDeep(form);
  const formVariant = formVariantsOptions.find(
    variant => variant.value === FormVariant.LOAN_SPECIFIC,
  );

  newForm.conditionTaskTypes[conditionId].conditionTaskTypes[taskTypeId].formVariant = formVariant;
  newForm.conditionTaskTypes[conditionId].conditionTaskTypes[taskTypeId].formId =
    uploadedForm.formId;

  return newForm;
};

export const getFormViewerDialogProps = ({ uploadedForm, onAssignClick }) => ({
  header: NEW_FORM_DIALOG_HEADER,
  body: dialogProps => (
    <FormViewer
      isDisableResetStateAction
      isNeedCloseButton
      isShowAssignFormIconButton
      customOnAssignFormClick={onAssignClick}
      formParams={buildFormParams(uploadedForm)}
      {...dialogProps}
    />
  ),
  disableEnforceFocus: true,
});

export const getCreateFormDialogProps = ({
  abortController,
  applicationId,
  onFinishFormUploading,
}) => ({
  header: NEW_FORM_DIALOG_HEADER,
  body: dialogProps => (
    <CreateFormModal
      isDisableResetStateAction
      isLoanSpecificForm
      isPdfOnly
      abortController={abortController}
      applicationId={applicationId}
      defaultDocumentTypeName={LoxDocumentTypeName}
      formAreaCode={NATIONAL_CATEGORY_CODE}
      onFinishFormUploading={onFinishFormUploading}
      {...dialogProps}
    />
  ),
  afterCloseCallback: () => abortController.abort(),
});

export const removeConditionFromForm = ({ form, conditionId }) => ({
  conditionTaskTypes: _.omit(form.conditionTaskTypes, conditionId),
  conditions: form.conditions.filter(({ id }) => id !== conditionId),
  conditionSets: form.conditionSets
    .map(({ links, ...conditionSet }) => ({
      ...conditionSet,
      links: links.filter(link => link.conditionId !== conditionId),
    }))
    .filter(({ links }) => !_.isEmpty(links)),
});

export const getActiveTabConditionIds = ({ isConditionsTab, conditions, conditionSets }) => {
  if (isConditionsTab) {
    return new Set(conditions.map(({ id }) => id));
  }

  const ids = new Set();

  conditionSets.forEach(({ links }) => {
    links.forEach(({ conditionId }) => ids.add(conditionId));
  });

  return ids;
};

export const getPreparedConditionTaskTypes = ({ conditionTaskTypes, activeTabConditionIds }) =>
  _.sortBy(
    _.values(conditionTaskTypes).filter(({ conditionId }) =>
      activeTabConditionIds.has(conditionId),
    ),
    [({ priorToType }) => priorToType?.order, 'number'],
  );

export const isConditionsPickerTab = activeTab => activeTab === PickerTab.CONDITIONS;
